<template>
  <div class="container">
    <b-row>
      <div class="col-sm-6">
        <div class="ld-card-header">
          <img :src="userData.logo" v-if="userData.logo" style="max-height: 50px;" />
          <img src="@/assets/images/logo-interra-2.svg" alt="interra logo" class="logo-img">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="float-right"  v-b-tooltip.hover :title="$gettext('Close')">
          <b-iconstack font-scale=".8" @click="$emit('closeModal')">
            <b-icon stacked icon="square"></b-icon>
            <b-icon stacked icon="x"></b-icon>
          </b-iconstack>
        </div>
      </div>
      <b-col sm="12"><hr></b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'
export default {
  name: 'modalHeader',
  mixins: [authMixin]
}
</script>
